import { Avatar, Box, CardMedia, Pagination, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import { getDiagnosticDashboardData } from "../../../redux/reducers/clinicSlice";
import { AppColors } from "../../../util/AppColors";
import { diagnosticsStatusList } from "../../../util/arrayList";

const initFilterValues = {
  status: { name: "All", value: "all" },
  petName: "",
  filter: "today",
};

const LabDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [filterValues, setFilterValues] = useState(initFilterValues);
  const { diagnosticDashboard } = useSelector((state) => state?.clinic);
  const profile = JSON.parse(localStorage.getItem("user"));
  const itemsPerLoad = 10;

  useEffect(() => {
    onApiCall();
  }, [filterValues?.filter, filterValues?.petName, filterValues?.status]);

  const onApiCall = (pge = 1) => {
    setPage(pge);
    let url = `&doctorId=${profile?.id}`;
    // page=${page}&itemSize=${itemsPerLoad}&
    const { status, petName, filter } = filterValues || {};
    const statusValue = status?.value;
    if (statusValue && statusValue !== "all") {
      url = `${url}&status=${statusValue}`;
    }
    if (petName) {
      url = `${url}&petName=${petName}`;
    }
    if (filter) {
      url = `${url}&filter=${filter}`;
    }
    dispatch(getDiagnosticDashboardData({ type: "all", url }));
  };

  const onChange = (name, value) => {
    setFilterValues({ ...filterValues, [name]: value });
  };

  const handleCardClick = (appointment) => {
    navigate("/lab-pet-details", {
      state: { appointment },
    });
  };

  const getGroomAppointments = () => {
    return (diagnosticDashboard?.records ?? [])?.flatMap((item) =>
      (item?.diagnostic ?? [])?.map((diag) => ({
        diagnostic: diag,
        appoinment: item?.appointment,
      })),
    );
  };

  const totalRecords = getGroomAppointments()?.length ?? 0;
  const totalPage = Math.ceil(totalRecords / itemsPerLoad);

  const getTableRecordsWithPagination = () => {
    const startIndex = (page - 1) * itemsPerLoad;
    const endIndex = startIndex + itemsPerLoad;
    return (getGroomAppointments() ?? [])?.slice(startIndex, endIndex);
  };

  return (
    <>
      <div
        className="flex-row-ali-cen back-white"
        style={{ padding: "12px 24px" }}
      >
        <div className="w30Per">
          <div className="flex-start">
            <Typography
              className={`font-bold fs14 cursor day-type-box ${
                filterValues?.filter === "today" ? "black" : "gray2"
              }`}
              onClick={() => onChange("filter", "today")}
            >
              Today
            </Typography>
            <Typography
              className={`font-bold fs14 cursor day-type-box ${
                filterValues?.filter === "week" ? "black" : "gray2"
              }`}
              onClick={() => onChange("filter", "week")}
            >
              Week
            </Typography>
            <Typography
              className={`font-bold fs14 cursor day-type-box ${
                filterValues?.filter === "all" ? "black" : "gray2"
              }`}
              onClick={() => onChange("filter", "all")}
            >
              All
            </Typography>
          </div>
        </div>
        <div className="w40Per flex-center">
          <CustomTextField
            value=""
            fullWidth
            backgroundColor={AppColors.lightBlue2}
            placeholder="Pet Name"
            label="Pet Name"
            handleChange={(e) => onChange("petName", e?.target?.value)}
            value={filterValues?.petName}
          />
        </div>
        {/* <div className="ph10pv3">
          <div className={`flex-center cursor pet-det-sel-tab`}>
            Lab Appointments
          </div>
        </div> */}
        <div className="w30Per">
          <div className="flex1-end">
            <div className="w70Per">
              <CustomSelect
                list={diagnosticsStatusList}
                value={filterValues?.status}
                handleChange={(e, value) => onChange("status", value)}
                search
                backgroundColor={AppColors.lightBlue2}
              />
            </div>
          </div>
        </div>
      </div>

      <Box className="pb-40 ph20">
        {/* Header */}
        <div className="flex-row-ali-cen">
          <div className="w10Per flex-center">
            <Typography className="txt-semi-bold fs16 blue-color">
              Date/Time
            </Typography>
          </div>
          <div className="w90Per" />
        </div>
        {/* Appointments List */}
        <div className="mt20 scroll-70vh">
          {getTableRecordsWithPagination()?.map((itm, index) => {
            const apnt = itm?.appoinment;
            // Create unique key combining appointmentId and diagnostic ID (or index)
            const uniqueKey = `${apnt?.appointmentId}-${
              itm?.diagnostic?.diagonosticId || index
            }`;
            return (
              <div key={uniqueKey} className="flex-row-ali-cen mb10">
                <div className="w10Per flex-center">
                  <div className="flex-center br5 txt-regular fs12">
                    {moment(new Date(itm?.diagnostic?.createdDate)).format(
                      "DD MMM YYYY, HH.mm",
                    )}
                  </div>
                </div>

                {/* Appointment Card */}
                <div className="w90Per pl20">
                  <div className="flex-row-ali-cen br15 lght-blu-bck-con">
                    {/* Pet Information */}
                    <div
                      className="flex-row-ali-cen w30Per cursor"
                      style={{ alignItems: "stretch" }}
                      onClick={() => handleCardClick(itm)}
                    >
                      <div
                        style={{
                          background: "#6d79fc",
                          width: 10,
                        }}
                        className="brl10"
                      />
                      <div className="ali-slf-cen pv10 ml5">
                        {apnt?.petImage ? (
                          <CardMedia
                            image={apnt?.petImage}
                            className="h50img ml5"
                          />
                        ) : (
                          <div className="flex-center h50img">
                            <Typography className="font-bold fs30 white-color capitalize">
                              {apnt?.petName?.[0]}
                            </Typography>
                          </div>
                        )}
                      </div>

                      <div className="ml10 pv10">
                        <div className="flex-row">
                          <Custom3dotString
                            str={apnt?.petName}
                            className="txt-semi-bold fs14"
                            length={30}
                          />
                          <Typography
                            className={`txt-regular ml3 capitalize ${
                              apnt?.gender === "male"
                                ? "card-blue-color"
                                : "card-rose-color"
                            }`}
                          >
                            ({apnt?.gender})
                          </Typography>
                        </div>
                        <Typography className="txt-regular card-black1 fs12 capitalize">
                          {apnt?.breed}
                        </Typography>
                        <div className="flex-row mt5">
                          <div className="flex-start">
                            <div className="flex-center">
                              <Avatar
                                src="/broken-image.jpg"
                                sx={{ width: 20, height: 20 }}
                              />
                            </div>
                          </div>
                          <div className="ml5 flex-center">
                            <Custom3dotString
                              str={apnt?.userName ?? ""}
                              className="font-bold fs12"
                              length={30}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Service Details */}
                    <div
                      className="flex-row-ali-cen w50Per"
                      style={{ alignItems: "stretch" }}
                    >
                      <div className="ver-bar-auto" />
                      <div className="ml10">
                        <div className="flex-row-ali-cen">
                          <Typography className="font-bold fs14 black">
                            {apnt?.serviceType}
                          </Typography>
                        </div>
                        <div className="flex-row-ali-cen">
                          <Typography className="txt-semi-bold fs14 gray20 mt5">
                            {apnt?.serviceNames
                              ?.flat(Infinity)
                              ?.map((item) => item?.serviceName)
                              ?.join(", ")}
                          </Typography>
                        </div>
                        <Typography className="txt-regular fs12 black26 mt5">
                          {apnt?.remarks}
                        </Typography>
                      </div>
                    </div>

                    {/* Status/Actions */}
                    <div className="w20Per">
                      <div className="flex-row-ali-cen">
                        <img
                          src={require(
                            `../../../assets/images/png/${
                              itm?.diagnostic?.status?.toLowerCase() ===
                              "in progress"
                                ? "infoBle.png"
                                : itm?.diagnostic?.status?.toLowerCase() ===
                                    "pending approval"
                                  ? "clkYel.png"
                                  : itm?.diagnostic?.status?.toLowerCase() ===
                                      "completed"
                                    ? "tick.png"
                                    : itm?.diagnostic?.status?.toLowerCase() ===
                                        "cancelled"
                                      ? "crossRed.png"
                                      : "calOrg.png"
                            }`,
                          )}
                          className="img-wh15"
                        />
                        <Typography className="font-medium fs12 black27 ml5">
                          {itm?.diagnostic?.status?.toLowerCase() ===
                          "in progress"
                            ? "Processing"
                            : itm?.diagnostic?.status}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          <div className="flex-end">
            <Pagination
              count={totalPage}
              variant="outlined"
              color="primary"
              page={page}
              onChange={(_, pge) => setPage(pge)}
            />
          </div>
        </div>
      </Box>
    </>
  );
};

export default LabDashboard;
